import {
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import * as types from './types';
import * as actions from './actions';

import { SETUP_TIMELINE } from '@store/timeline/dashboard/types';

function* setupTempDashboard(action) {
  const { dashboardType, query }  = action;
  // TODO: handle errors
  if ( dashboardType === 'timeline' ) {
    yield put({ type: SETUP_TIMELINE, query });
  }
  yield put(actions.done());
}

function* watchSetup() {
  yield takeLatest(types.SETUP, setupTempDashboard);
}

export default [
  watchSetup,
];
